export default {
    mounted() {
        document.addEventListener(
            'webkitfullscreenchange',
            this.exitHandler,
            false
        )
        document.addEventListener(
            'mozfullscreenchange',
            this.exitHandler,
            false
        )
        document.addEventListener('fullscreenchange', this.exitHandler, false)
        document.addEventListener('MSFullscreenChange', this.exitHandler, false)
        this.save_height()
    },
    methods: {
        exitHandler() {
            const chart = this.$children[0].chart
            if (
                !document.webkitIsFullScreen &&
                !document.mozFullScreen &&
                !document.msFullscreenElement
            ) {
                setTimeout(() => {
                    chart.setSize(
                        this.chart_offsetWidth,
                        this.chart_offsetHeight
                    )
                }, 1)
            } else {
                chart.setSize(null, null)
            }
        },

        save_height() {
            this.class_info = document.getElementsByClassName(
                'stock_chart_resize'
            )

            this.chart_offsetHeight = this.class_info[0].style.height
            this.chart_offsetWidth = this.class_info[0].style.width

            this.chart_offsetHeight = this.chart_offsetHeight.replace('px', '')
            this.chart_offsetWidth = this.chart_offsetWidth.replace('px', '')
        }
    }
}
